import { MailConfirmation } from "@/features/authenticate/components/mailConfirmation";
import { Container, Stack } from "@mantine/core";

export const ForgetPasswordConfirmationPage = () => {
	return (
		<Container
			size="xl"
			style={{
				height: "100vh",
			}}
		>
			<Stack align="center" justify="center" h="100%">
				<MailConfirmation />
			</Stack>
		</Container>
	);
};
